import { Pagination } from "src/app/core/utils/pagination.entity";
import { AudienceEntity } from "./audience.entity";

export abstract class AudiencePagination extends Pagination<AudienceEntity[]> {}